export default "__VITE_ASSET__f6219234__"